module.exports = __webpack_public_path__ + "img/game_aoe_mod_room_name_1.08e6ac37.jpg";